import compose from 'lodash/fp/compose'
import map from 'lodash/fp/map'
import omit from 'lodash/fp/omit'
import getOr from 'lodash/fp/getOr'
import * as yup from 'yup'
import { FINANCIAL_TYPES_VALUES, HOW_RETURN_VALUES } from '../../constants'
import { MIN_50000, MIN_30000 } from '../../../../../utils/validations/constants'

const baseSchema = {
  finnancial_type: yup
    .number()
    .required()
    .oneOf(Object.values(FINANCIAL_TYPES_VALUES)),
  how_much: yup
    .number()
    .required(),
  how_much_time_months: yup
    .mixed()
    .when('finnancial_type', {
      is: value => value && value !== FINANCIAL_TYPES_VALUES.avales,
      then: yup.number().required(),
      otherwise: yup
        .mixed()
        .transform(v => null) // send as null
        .notRequired()
    })
}

const solicitudeValidationSchema = yup.object().shape({
  ...baseSchema,
  is_client: yup
    .boolean()
    .required(),
  how_much: yup
    .number()
    .required()
    .when('is_client', {
      is: value => value === true,
      then: yup.number().min(30000, MIN_30000),
      otherwise: yup
        .number()
        .min(50000, MIN_50000)
    }),
  how_plan_return_it: yup
    .number()
    .required()
    .oneOf(Object.values(HOW_RETURN_VALUES)),
  extra: yup.array().of(yup.object().shape(baseSchema))
})

const mapPropsToValues = ({ application }) => ({
  finnancial_type: getOr('', 'solicitude.finnancial_type')(application),
  how_much: getOr('', 'solicitude.how_much')(application),
  how_much_time_months: getOr('', 'solicitude.how_much_time_months')(application),
  how_plan_return_it: getOr('', 'solicitude.how_plan_return_it')(application),
  is_client: getOr('', 'solicitude.is_client')(application),
  extra: compose(
    map(omit(['id', 'solicitude_id'])),
    getOr([], 'solicitude.extra')
  )(application)
})

export default {
  mapPropsToValues,
  validationSchema: solicitudeValidationSchema
}
